import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1dac4180")

_pushScopeId("data-v-1dac4180")
const _hoisted_1 = { class: "lexicon-default" }
const _hoisted_2 = { class: "control-bar" }
const _hoisted_3 = { class: "search-wrap" }
const _hoisted_4 = { class: "table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_m_table = _resolveComponent("m-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          placeholder: "输入词汇",
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
          class: "input-with-select",
          size: "medium",
          style: {"width":"350px"}
        }, {
          append: _withId(() => [
            _createVNode(_component_el_button, {
              size: "medium",
              icon: "el-icon-search",
              onClick: _ctx.search
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_m_table, {
        data: _ctx.tableList,
        loading: _ctx.loading,
        ref: "mTable",
        pagination: _ctx.pagination,
        onCurrentChange: _ctx.pageChange
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            prop: "content",
            label: "敏感词汇"
          }),
          _createVNode(_component_el_table_column, {
            prop: "replace",
            label: "替换词汇"
          })
        ]),
        _: 1
      }, 8, ["data", "loading", "pagination", "onCurrentChange"])
    ])
  ]))
})